@if (mode) {
  <div [style.display]="!show ? 'none' : null">
    <ion-toolbar>
      <ion-item id="title-item" slot="start" color="primary" lines="none">
        <ion-select
          data-cy="msgEditorModeSelect"
          [(ngModel)]="mode"
          (ionChange)="clearValidationErrors()"
          interface="popover"
          label="Vytvořit"
          labelPlacement="fixed"
        >
          @for (mode of messageModes; track mode) {
            <ion-select-option [value]="mode">
              {{ mode.nameInDeclination }}
            </ion-select-option>
          }
        </ion-select>
      </ion-item>
      <ion-buttons slot="end">
        <ion-button (click)="hide()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    @if (validationErrors.size) {
      <ion-item data-cy="msgEditorErrors">
        @for (e of validationErrors; track e; let isLast = $last) {
          <ion-text color="danger">{{ e }}{{ isLast ? '' : ',&nbsp;' }}</ion-text>
        }
      </ion-item>
    }
    <ion-item slot="start" [style.display]="!mode.hasRecipient ? 'none' : null">
      <ion-label position="fixed">
        Komu
        <ion-text color="danger">*</ion-text>
      </ion-label>
      <ionic-selectable
        #recipientSelect
        data-cy="msgEditorRecipient"
        [(ngModel)]="msgRecipients"
        [items]="allowedRecipients"
        [canSearch]="true"
        [shouldFocusSearchbar]="true"
        (onSearch)="searchRecipient($event)"
      >
        <ng-template ionicSelectableItemTemplate let-recipient="item">
          {{ recipient?.title }}
        </ng-template>
        <ng-template ionicSelectableValueTemplate let-recipient="value">
          {{ recipient?.title }}
        </ng-template>
        <ng-template ionicSelectableHeaderTemplate>
          <ion-toolbar>
            <ion-buttons slot="primary">
              <ion-button (click)="onRecipientSelectClose()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title>Komu</ion-title>
          </ion-toolbar>
        </ng-template>
        <ng-template ionicSelectableCloseButtonTemplate>
          <ion-icon name="close" style="font-size: 24px"></ion-icon>
        </ng-template>
      </ionic-selectable>
    </ion-item>
    <ion-item slot="start" [style.display]="!mode.subjectAllowed ? 'none' : null">
      <ion-input data-cy="msgEditorSubject" [(ngModel)]="msgSubject" label="Předmět" labelPlacement="fixed">
        <ion-text color="danger" slot="label">*</ion-text>
      </ion-input>
    </ion-item>
    <ion-item [style.display]="!mode.attachmentAllowed ? 'none' : null">
      @if (msgAttachmentName) {
        <ion-buttons slot="start">
          <ion-button color="secondary" expand="block" fill="solid" (click)="clearFileInput()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      }
      @if (msgAttachmentName) {
        <span slot="start">
          <ion-icon name="attach-outline"></ion-icon>
          {{ msgAttachmentName }}
        </span>
      }
      <ion-buttons slot="end">
        <ion-button color="secondary" expand="block" fill="solid" (click)="selectFile()">
          <ion-icon name="cloud-upload"></ion-icon>
          &nbsp;Nahrát přílohu
        </ion-button>
        <input type="file" #fileInput style="display: none" (change)="onFileInput()" />
      </ion-buttons>
    </ion-item>
    <ejs-richtexteditor
      data-cy="msgEditorBody"
      class="rte"
      [toolbarSettings]="tools"
      [insertImageSettings]="rteInsertImageSettings"
      [(ngModel)]="msgBody"
    ></ejs-richtexteditor>
  </div>
}
